import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import EditDeleteButton from "components/table/EditDeleteButton";
import React from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import HourRentalPeriodicHikeDayDrawer from "components/drawer/HourRentalPeriodicHikeDayDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import dayjs from "dayjs";

const HourRentalPeriodicHikeDayTable = ({
  hourRentalPeriodicHikeDay,
  perpage,
  currentPage,
  hideDelete,
  hideEdit,
}) => {
  const { title, serviceId, handleModalOpen, handleUpdate } = useToggleDrawer();
  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <HourRentalPeriodicHikeDayDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {hourRentalPeriodicHikeDay?.slice(0, perpage).map((data, index) => (
          <React.Fragment key={data.id}>
            {data["vehicle_type_id"].map((item, vehicleIndex) => (
              <TableRow key={`${data.id}-${vehicleIndex}`}>
                {/* Display Sl.No., City, Start Date, and End Date only on the first row of each vehicle type group */}
                {vehicleIndex === 0 && (
                  <>
                    <TableCell
                      rowSpan={data["vehicle_type_id"].length}
                      className="text-center text-xs"
                    >
                      {(currentPage - 1) * perpage + index + 1}
                    </TableCell>

                    <TableCell
                      className="text-sm text-center"
                      rowSpan={data["vehicle_type_id"].length}
                    >
                      {data["city_names"]}
                    </TableCell>

                    <TableCell
                      className="text-sm text-center"
                      rowSpan={data["vehicle_type_id"].length}
                    >
                      {dayjs(data["start_date"]).format("DD-MM-YYYY")}
                    </TableCell>

                    <TableCell
                      rowSpan={data["vehicle_type_id"].length}
                      className="text-sm text-center"
                    >
                      {dayjs(data["end_date"]).format("DD-MM-YYYY")}
                    </TableCell>
                  </>
                )}

                {/* Display Vehicle Type and Hike (%) for each entry */}
                <TableCell className="text-sm text-center">
                  {data["vehicle_type_names"][item]}
                </TableCell>
                <TableCell className="text-sm text-center">
                  {data["hike"][item]}%
                </TableCell>
                {/* Display Actions column only on the first row of each grouped vehicle type */}
                {vehicleIndex === 0 && (
                  <TableCell
                    rowSpan={data["vehicle_type_id"].length}
                    className="text-center"
                  >
                    <EditDeleteButton
                      title={data["Hour Rental"]}
                      id={data.id}
                      handleUpdate={handleUpdate}
                      handleModalOpen={handleModalOpen}
                      hideDelete={hideDelete}
                      hideEdit={hideEdit}
                    />
                  </TableCell>
                )}
              </TableRow>
            ))}
          </React.Fragment>
        ))}
      </TableBody>
    </>
  );
};

export default HourRentalPeriodicHikeDayTable;
